module.exports = "/static/videos/lake.mp4";